// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"8d682a36","386":"39d49056","445":"043b7377","635":"15a552d5","733":"59cbc46f","787":"07fe36e0"}[chunkId] + ".chunk.js";
};